<template>
<div class="encyclopedias">
    <div class="head">珠宝百科</div>
    <div class="filter">
        <span :class="{active:active == 0}" @click="active = 0">珠宝讲堂</span>
        <el-divider direction="vertical"></el-divider>
        <span :class="{active:active == 1}" @click="active = 1">最新活动</span>
    </div>
    <div class="wrap">
        <div v-for="(item,index) in datas.data" :key="index" :class="{no:(index+1) % 3 ==0 && index>0}" @click="$router.push({path:'/ency-detail',query:{id:item.id}})">
            <img :src="item.img" alt />
            <p class="name text-overflow-more text-overflow-more-2">{{item.title}}</p>
            <div class="down">
                <p class="desc text-overflow-more text-overflow-more-2">{{item.intro}}</p>
            </div>
        </div>
    </div>
    <el-pagination class="pc" layout="prev, pager, next" :page-size="9" :total="datas.total || 0" @current-change="chage"></el-pagination>
    <div class="btn mobile" @click="mobileChange(page +1)">加载更多</div>
</div>
</template>

<script>
export default {
    data() {
        return {
            active: this.$route.query.type || 0,
            datas: {
                data: [],
            },
            page: 1,
        };
    },
    watch: {
        active(e) {
            this.page = 1;
            this.getData();
        },
    },

    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.axios
                .post("news/index", {
                    type: Number(this.active) + 1,
                    per_page: 9,
                    page: this.page,
                })
                .then((r) => {
                    this.datas = {
                        ...r,
                    };
                });
        },
        mobileChange(e) {
            this.page = e;
            this.axios
                .post("news/index", {
                    type: Number(this.active) + 1,
                    per_page: 9,
                    page: this.page,
                })
                .then((r) => {
                    this.datas.data = this.datas.data.concat(r.data);
                });
        },
        chage(e) {
            this.page = e;
            this.getData();
        },
    },
};
</script>

<style lang="less" scoped>
.encyclopedias {
    padding-top: 0.2rem;
}

.filter {
    text-align: center;
    margin-top: 0.24rem;

    span {
        font-size: 0.14rem;
        font-family: FZShuSong-Z01T;
        cursor: pointer;
        color: rgba(16, 16, 16, 0.5);
        margin: 0 0.25rem;
        padding: 0.05rem;
    }

    span.active {
        color: rgba(16, 16, 16, 1);
        border-bottom: 1px solid black;
    }
}

.wrap {
    padding: 0.6rem 3.6rem;
    display: flex;
    flex-wrap: wrap;

    &>div {
        width: 30%;
        margin-right: 5%;

        font-size: 0.14rem;
        margin-bottom: 0.56rem;
        cursor: pointer;
        transition: all 0.3s linear;

        .down {
            padding: 0.1rem;
        }

        img {
            width: 100%;
            height: 2.16rem;
        }

        .name {
            font-family: FZShuSong-Z01T;
            margin: 0.11rem 0;
            padding: 0 0.1rem;
        }

        .desc {
            color: rgba(32, 32, 32, 0.5);
            line-height: 24px;
        }
    }

    div.no {
        margin-right: 0;
    }

    &>div:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    }
}

@media (max-width: 767px) {
    .filter {
        span {
            font-size: 14px;
            padding: 5px;
        }
    }

    .wrap {
        padding: 20px 7.5%;
        justify-content: space-between;
        display: block;

        &>div {
            width: 100%;
            margin-right: 0;
            margin-bottom: 30px;

            img {
                height: 100px;
                object-fit: cover;
            }

            .name {
                font-size: 16px;
            }

            .desc {
                font-size: 12px;
                padding: 0;
            }
        }
    }

    .btn {
        width: 50%;
        height: 30px;
        background: rgba(0, 0, 0, 1);
        margin: 0.9rem auto 0;
        cursor: pointer;
        text-align: center;
        line-height: 30px;
        color: white;
        font-size: 14px;
        font-family: FZShuSong-Z01T;
        transition: all 0.3s linear;
        user-select: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/encyclopedias.vue